import React from "react";

const AccountInfoCard = (props) => {
  const isAccountVerified = props.$store?.user?.isAccountVerified;
  return (
    <div className="card profile_card">
      <div className="card-header border-0">
        <div className="d-flex align-items-center">
          <div className="img_outer">
            <img src={imagepaths.accountIcon} alt="aadhar" />
          </div>
          <h5 className="title ms-2">Account Info</h5>
        </div>
        <div className="action_box d-flex align-items-center">
          {isAccountVerified ? (
            <i className="fa fa-check check_icon"></i>
          ) : (
            <>
              <button
                onClick={(...args) => props.onEdit(...args, "accountinfo")}
              >
                <i className="fa fa-pencil"></i>
              </button>
            </>
          )}
        </div>
      </div>
      <div className="card-body">
        <h5>Account holder name</h5>
        <p>{props?.accountinfodata?.bank_account_holder_name || "-"}</p>
        <div className="row">
          <div className="col">
            <h5>Account No.</h5>
            <p>{props?.accountinfodata?.bank_account_number || "-"}</p>
          </div>
          <div className="col">
            <h5>Account Type</h5>
            <p>{props?.accountinfodata?.bank_account_type || "-"}</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <h5>Bank name</h5>
            <p>
              {props?.accountinfodata?.bank_account_holder_bank_name || "-"}
            </p>
          </div>
          <div className="col">
            <h5>IFSC Code</h5>
            <p>
              {props?.accountinfodata?.bank_account_holder_bank_IFSC || "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default constore(AccountInfoCard);
